<template>
  <slot v-if="status === 'loading'" name="loading">
    <TextSkeleton v-bind="$attrs" />
  </slot>

  <slot v-else-if="status === 'error'" name="error">
    <TextSkeleton v-bind="$attrs" is-error />
  </slot>

  <slot v-else v-bind="$attrs" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { QueryStatus, queryStatus } from '@libs/use';

import TextSkeleton from '@/components/TextSkeleton.vue';

type ComponentStatePropsType = { fetchStatus: QueryStatus | QueryStatus[] };

const props = defineProps<ComponentStatePropsType>();

const status = computed(() => {
  const statuses = Array.isArray(props.fetchStatus)
    ? props.fetchStatus
    : [props.fetchStatus];

  if (statuses.includes(queryStatus.error)) {
    return queryStatus.error;
  }

  if (statuses.includes(queryStatus.loading)) {
    return queryStatus.loading;
  }

  return queryStatus.success;
});
</script>
